// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2aDn8","footer":"ModalError_footer__3ZCw7"};